import styled from "styled-components";

const GoldImage = styled.img`
  width: 20rem;
  margin: 4rem;
`

export default GoldImage;
